import { ACCOUNT_ROLE_COPY } from "@common/constants/domains/accounting/accountRole";
import { SCHEDULE_SOURCE_MOVE_CONFIRM_TITLE } from "@common/helpers/domains/accounting/scheduleSourceMoves";
import { AccountRole } from "@common/types/domains/accounting/account";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";

export function scheduleSourceMoveConfirmCopy(
    documentType: ScheduleSourceType.bill | ScheduleSourceType.invoice,
): {
    title: string;
    body: string;
    confirm: string;
    cancel: string;
} {
    const document =
        documentType === ScheduleSourceType.bill
            ? {
                  noun: "bill",
                  account: ACCOUNT_ROLE_COPY[AccountRole.accountsPayable].label,
              }
            : {
                  noun: "invoice",
                  account:
                      ACCOUNT_ROLE_COPY[AccountRole.accountsReceivable].label,
              };
    return {
        title: SCHEDULE_SOURCE_MOVE_CONFIRM_TITLE,
        body: `Matching moves the schedule onto the ${document.noun}. The payment settles ${document.account}.`,
        confirm: "Move schedule and match",
        cancel: "Cancel",
    };
}
